// Constants
import {
  LOAN_APPLICATION_DETAILS,
  SAVE_APPLICATION_ID,
  CLEAR_LOAN_APPLICATION_DETAILS,
  LOAN_APPLICATION_BASIC_INFO_DETAILS,
  RESET_BASIC_INFO,
} from "./Constants";

const INTIAL_STATE = {
  loanApplicationDetails: {},
  applicationId: null,
};

export default function loanApplicationListReducer(state = INTIAL_STATE, action) {
  switch (action.type) {
    case LOAN_APPLICATION_DETAILS:
      return {
        ...state,
        loanApplicationDetails: {
          ...state.loanApplicationDetails,
          ...action.loanApplicationDetails,
          basicInfo: action.loanApplicationDetails?.basicInfo
            ? action.loanApplicationDetails.basicInfo
            : state.loanApplicationDetails.basicInfo,
          loanInfo: action.loanApplicationDetails.loanInfo
            ? action.loanApplicationDetails.loanInfo
            : state.loanApplicationDetails.loanInfo,
          income: action.loanApplicationDetails.income
            ? action.loanApplicationDetails.income
            : state.loanApplicationDetails.income,
          addInfo: action.loanApplicationDetails.addInfo
            ? action.loanApplicationDetails.addInfo
            : state.loanApplicationDetails.addInfo,
          expenses: action.loanApplicationDetails.expenses
            ? action.loanApplicationDetails.expenses
            : state.loanApplicationDetails.expenses,
          documents: action.loanApplicationDetails.documents
            ? action.loanApplicationDetails.documents
            : state.loanApplicationDetails.documents,
          incompleteInfo: action.loanApplicationDetails.incompleteInfo
            ? action.loanApplicationDetails.incompleteInfo
            : state.loanApplicationDetails.incompleteInfo,
          status: action.loanApplicationDetails.status
            ? action.loanApplicationDetails.status
            : state.loanApplicationDetails.status,
        },
      };
    case LOAN_APPLICATION_BASIC_INFO_DETAILS:
      return {
        ...state,
        loanApplicationDetails: {
          ...state.loanApplicationDetails,
          clientInfo: action.data,
        },
      };
    case RESET_BASIC_INFO:
      return {
        ...state,
        loanApplicationDetails: {
          ...state.loanApplicationDetails,
          clientInfo: action.data,
          basicInfo: null,
          loanInfo: null,
          income: null,
          addInfo: null,
          expenses: null,
          documents: null,
          status: null,
        },
      };

    case SAVE_APPLICATION_ID:
      return {
        ...state,
        applicationId: action.loanApplicationId,
      };

    case CLEAR_LOAN_APPLICATION_DETAILS:
      return INTIAL_STATE;

    default:
      return state;
  }
}
